import React from 'react';

import Button from 'components/Button';
import Message from 'components/Message';
import NestedLink from 'components/NestedLink';
import { usePromoCountdownBannerVisibility } from 'components/PromoCountdownBanner/usePromoCountdownBannerVisibility';
import Typography from 'components/Typography';

import { useAuth } from 'hooks/useAuth';
import useSubscriptionPlans from 'hooks/useSubscriptionPlans';

import './style.scss';

const StickyBanner = React.forwardRef<HTMLDivElement>((_, ref) => {
  const { hasPremiumAccess } = useAuth();
  const { isVisible: isPromoCountdownBannerVisible } =
    usePromoCountdownBannerVisibility();
  const { maxTrialDuration } = useSubscriptionPlans();

  if (hasPremiumAccess || isPromoCountdownBannerVisible) {
    return null;
  }

  return (
    <div className="StickyBanner" ref={ref}>
      <NestedLink to="/sign-up">
        <Typography variant="h3" color="white">
          <Message
            message={{
              id: 'components.NewExplorePage.StickyBanner.testPeriod',
              values: { days: maxTrialDuration },
            }}
          />
        </Typography>
        <Button
          small
          title={{ id: 'components.NewExplorePage.StickyBanner.button' }}
        />
      </NestedLink>
    </div>
  );
});

export default StickyBanner;
